import React from 'react';
import { FiCode } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="py-8 border-t border-slate-800/50 bg-slate-950">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2 font-display font-bold text-lg text-slate-500">
          <FiCode className="text-indigo-500" />
          <span>Dhaanu<span className="text-indigo-500">.</span></span>
        </div>
        <div className="text-slate-600 text-sm">
          © {new Date().getFullYear()} Dhaanu. All rights reserved. Built using Greta.
        </div>
      </div>
    </footer>
  );
};

export default Footer;